<template>
    <div class="eval-check-person-range">
      <section class="yxt-upload-explain__section">
        <!--说明-->
        <ul class="yxt-upload-explain-list">
          <li>
            <span class="yxt-upload-explain-num color-gray-8">1</span>
            <div
              class="standard-size-14 color-gray-10 yxt-upload-explain-title"
            >
              {{
                $t("pc_gwnl_eval_selectedModel_title")
              }}
              <!-- 已选择的模型 -->
            </div>
            <div class="yxt-upload-explain-summary color-gray-8">
              {{ peopleName }}
            </div>
          </li>
          <li>
            <span class="yxt-upload-explain-num color-gray-8">2</span>
            <div
              class="standard-size-14 color-gray-10 yxt-upload-explain-title"
            >
              {{
                $t("pc_gwnl_eval_selectedModel_downloadTemplate_tips")
              }}
              <!-- 根据选择的模型点击“下载”自动生成需要的导入模板文件。 -->
            </div>
            <div class="yxt-upload-explain-summary color-gray-8">
              <span class="color-red-6">{{
                $t('pc_gwnl_import_readInstructions')
              }}</span>
              {{ $t('pc_gwnl_import_fillRequired') }}
            </div>
            <yxt-button
              class="mt16"
              type="primary"
              :loading="btnDisabled"
              @click="downloadExcel"
            >
              {{ $t('pc_gwnl_import_download') }}
            </yxt-button>
          </li>
          <li>
            <span class="yxt-upload-explain-num color-gray-8">3</span>
            <div
              class="standard-size-14 color-gray-10 yxt-upload-explain-title"
            >
              {{ $t('pc_gwnl_import_instruction1') }}
            </div>
            <div class="yxt-upload-explain-summary color-gray-8">
              {{ $t('pc_gwnl_import_instruction2') }}
            </div>
          </li>
        </ul>
        <!--上传-->
        <div v-if="step === 1" class="yxt-upload-container">
          <yxtbiz-upload
            ref="bizUpload"
            source="501"
            config-key="AttachConfigKey"
            module-name="attach"
            function-name="import"
            :app-code="module"
            :before-upload="beforeUpload"
            :on-progress="onProgress"
            :on-uploaded="onUploaded"
            :on-error="onError"
            :drag="true"
            filters=".xlsx,.xls"
            :files-filter="filesFilter"
          >
            <div slot="tip">
              {{ $t('pc_gwnl_import_supportExtension') }}
            </div>
          </yxtbiz-upload>
        </div>
        <div v-if="step === 3" class="yxt-upload-container">
          <ul class="yxt-upload-item-list">
            <li class="is-completed color-primary-6">
              <span class="yxt-upload-status" />
              <yxt-row
                type="flex"
                align="middle"
                class="color-gray-10 yxt-upload-item-title"
              >
                {{ file.name }}
                <yxt-button type="primary" @click="reset">
                  {{
                    successCount > 0 && failedCount > 0
                      ? this.$t('cc_btn_continueupload')
                      : this.$t('pc_gwnl_import_reupload')
                  }}
                </yxt-button>
              </yxt-row>
              <yxt-row
                type="flex"
                align="middle"
                class="standard-size-12 lh20 mt4"
              >
                <yxt-link :underline="false" type="success">
                  <i class="yxt-icon-success" />
                </yxt-link>
                <span class="color-gray-8 ml3">{{
                  $t('pc_gwnl_import_uploadSuccess')
                }}</span>
              </yxt-row>
            </li>
            <li v-if="checking" class="is-active color-primary-6">
              <span class="yxt-upload-status" />
              <div class="color-gray-10 yxt-upload-item-title">
                {{ $t('pc_gwnl_import_msg_checkingFormat') }}
              </div>
              <yxt-row
                type="flex"
                align="middle"
                class="standard-size-12 lh20 mt4"
              >
                <span class="color-gray-8 ml16">{{
                  $t('pc_gwnl_import_checking')
                }}</span>
              </yxt-row>
            </li>
            <li
              v-if="failedCount > 0 && successCount === 0"
              class="is-active color-primary-6"
            >
              <span class="yxt-upload-status" />
              <yxt-row
                type="flex"
                align="middle"
                class="color-gray-10 yxt-upload-item-title"
              >
                {{ $t('pc_gwnl_import_abnormalFormat') }}
              </yxt-row>
              <yxt-row
                type="flex"
                align="middle"
                class="standard-size-12 lh20 mt4"
              >
                <yxt-link :underline="false" type="warning">
                  <i class="yxt-icon-warning" />
                </yxt-link>
                <span class="color-gray-8 ml3">{{
                  $t('pc_gwnl_import_checkFailed')
                }}</span>
                <yxt-link
                  class="standard-size-12 ml8"
                  type="primary"
                  :underline="false"
                  @click="downloadError"
                >
                  {{ $t('pc_gwnl_import_downloadErrDes') }}
                </yxt-link>
              </yxt-row>
            </li>
            <li v-if="showError" class="is-active color-primary-6">
              <span class="yxt-upload-status" />
              <yxt-row
                type="flex"
                align="middle"
                class="color-gray-10 yxt-upload-item-title"
              >
                {{ $t('pc_gwnl_import_selectAgain') }}
              </yxt-row>
              <yxt-row
                type="flex"
                align="middle"
                class="standard-size-12 lh20 mt4"
              >
                <yxt-link :underline="false" type="danger">
                  <i class="yxt-icon-error" />
                </yxt-link>
                <span class="color-gray-8 ml3">{{
                  errorMsg || $t('pc_gwnl_import_checkFail')
                }}</span>
              </yxt-row>
            </li>

            <li
              v-if="!checking && successCount > 0"
              class="is-completed color-primary-6"
            >
              <span class="yxt-upload-status" />
              <yxt-row
                type="flex"
                align="middle"
                class="color-gray-10 yxt-upload-item-title"
              >
                {{ $t('pc_gwnl_import_checkCompleted') }}
              </yxt-row>
              <yxt-row
                type="flex"
                align="middle"
                class="standard-size-12 lh20 mt4"
              >
                <yxt-link :underline="false" type="success">
                  <i class="yxt-icon-success" />
                </yxt-link>
                <span class="color-gray-8 ml3">{{
                  $t('pc_gwnl_import_checkPassed')
                }}</span>
              </yxt-row>
            </li>
            <li
              v-if="successCount > 0 && failedCount === 0"
              class="is-active color-primary-6"
            >
              <span class="yxt-upload-status" />
              <yxt-row
                type="flex"
                align="middle"
                class="color-gray-10 yxt-upload-item-title"
              >
                {{ $t('pc_gwnl_import_importSuccessCount1') }}
                <yxt-link
                  class="standard-size-14"
                  :underline="false"
                  type="success"
                >
                  {{ successCount }}
                </yxt-link>
                {{ $t('pc_gwnl_import_importSuccessCount2') }}
              </yxt-row>
              <yxt-row
                type="flex"
                align="middle"
                class="standard-size-12 lh20 mt4"
              >
                <yxt-link :underline="false" type="success">
                  <i class="yxt-icon-success" />
                </yxt-link>
                <span class="color-gray-8 ml3">{{
                  $t('pc_gwnl_import_importSuccess')
                }}</span>
              </yxt-row>
            </li>
            <li
              v-if="successCount > 0 && failedCount > 0"
              class="is-active color-primary-6"
            >
              <span class="yxt-upload-status" />
              <yxt-row
                type="flex"
                align="middle"
                class="color-gray-10 yxt-upload-item-title"
              >
                <yxt-link
                  class="standard-size-14"
                  :underline="false"
                  type="success"
                >
                  {{ successCount }}
                </yxt-link>
                {{ $t('pc_gwnl_import_importSuccessFailed1') }}
                <yxt-link
                  class="standard-size-14"
                  :underline="false"
                  type="danger"
                >
                  {{ failedCount }}
                </yxt-link>
                {{ $t('pc_gwnl_import_importSuccessFailed2') }}
              </yxt-row>
              <yxt-row
                type="flex"
                align="middle"
                class="standard-size-12 lh20 mt4"
              >
                <yxt-link :underline="false" type="success">
                  <i class="yxt-icon-success" />
                </yxt-link>
                <span class="color-gray-8 ml3">{{
                  $t('pc_gwnl_import_importCompleted')
                }}</span>
                <yxt-link
                  class="standard-size-12 ml8"
                  type="primary"
                  :underline="false"
                  @click="downloadError"
                >
                  {{ $t('pc_gwnl_import_btn_downloadfaileddata') }}
                </yxt-link>
              </yxt-row>
            </li>

            <li v-if="successCount === 0" class="color-primary-6">
              <span class="yxt-upload-status" />
              <div class="color-gray-8 yxt-upload-item-title">
                {{ $t('pc_gwnl_import_downloadData') }}
              </div>
            </li>
          </ul>
        </div>
      </section>
    </div>

    <!-- <div slot="footer">
      <yxt-button plain @click="cancel">
        {{ $t('pc_gwnl_global_btn_previous') }}
      </yxt-button>
      <yxt-button type="primary" @click="submit">
        {{ $t('pc_gwnl_web_homework_btn_done') }}
      </yxt-button>
    </div> -->

</template>
<script>

import { downLoadReportsProjectTemplate } from '../service.js';
// const packageJson = require('../../../../../../package.json')
export default {
  components: {},
  props: {
    models: {
      type: Array,
      default: []
    },
    module: {
      type: String,
      default: 'evalpc'
    },
    // promise结构函数
    importMethods: {
      type: Function,
      default: () => {
        return new Promise((resolve, reject) => {
          reject(new Error('import error'));
        });
      }
    }
  },
  data() {
    return {
      btnDisabled: false,
      visible: false,
      file: {},
      value: true,
      ruleForm: {
        type: 1
      },
      step: 1,
      checking: false, // 检查中
      showError: false, // 非正常数据模板文件，请重新选择文件！检查失败
      failedCount: 0, // 失败n条
      successCount: 0, // 成功导入n条数据
      filePath: '', // 异常说明链接
      errorMsg: ''
    };
  },
  computed: {
    peopleName() {
      if (!this.models.length) {
        return this.$t('pc_talent_msg_noModel').d('没有传入模型');
      }
      const namelist = this.models.map((item) => item.name);
      let str = '';
      if (namelist.length >= 2) {
        str = `${namelist.join('，')}`;
      } else {
        str = `${namelist.join('，')}`;
      }
      return str;
    }
  },
  methods: {
    cancel() {
      this.visible = false;
    },
    submit() {
      this.visible = false;
      this.$emit('success');
    },
    close() {
      this.reset();
      this.$emit('close');
    },
    cancleMessageBox(done) {
      done();
    },
    // 重新上传
    reset() {
      this.file = {};
      this.value = true;
      this.checking = false;
      this.showError = false;
      this.failedCount = 0;
      this.successCount = 0;
      this.filePath = '';
      this.step = 1;
      this.errorMsg = '';
    },
    throttle(method) {
      clearTimeout(method.tId);
      method.tId = setTimeout(() => {
        method();
      }, 1000);
    },
    // 下载异常说明
    downloadError() {
      if (!this.clicked) {
        window.location.href = this.filePath;
      } else {
        this.$message.warning(this.$t('pc_gwnl_import_downloading'));
      }
      this.clicked = true;
      this.throttle(() => {
        this.clicked = false;
      });
    },
    async handleImport(file) {
      this.step = 3;
      // 正在检验数据格式
      // 检查中...
      this.checking = true;
      this.errorMsg = '';
      console.log(file);
      this.importMethods(file)
        .then((res) => {
          this.checking = false;
          if (res.failedCount > 0) {
            this.filePath = res.filePath;
          }
          this.successCount = res.successCount;
          this.failedCount = res.failedCount;
          if (res.totalCount === 0) {
            this.checking = false;
            this.showError = true;
          }
          if (this.failedCount > 0) {
            this.showError = true;
          } else {
            if (this.successCount > 0) {
              this.$emit('success');
            }
          }
        })
        .catch((err) => {
          if (
            err &&
            err.error &&
            err.error.key === 'apis.skill.import.excel.sheetName.error'
          ) {
            this.errorMsg = 'sheet' + this.$t('pc_gwnl_eval_excel_name_error');
          } else {
            this.$talentHandleError(err);
          }
          // 非正常数据模板文件，请重新选择文件！
          // 检查失败
          this.checking = false;
          this.showError = true;
        });
    },
    selectType(type) {
      if (this.ruleForm.type === type) return;
      this.ruleForm.type = type;
    },
    downloadExcel() {
      this.btnDisabled = true;
      downLoadReportsProjectTemplate(this.models.map(item => item.id))
        .then((res) => {
          this.btnDisabled = false;
          window.location.href = res.fileUrl;
        })
        .catch(() => {
          this.btnDisabled = false;
        });
    },
    show() {
      this.visible = true;
    },
    onError(e) {
      if (e === 'forbidden') {
        this.$message.warning(this.$t('pc_gwnl_import_wrongFormat'));
      }
    },
    httpRequest(v) {
      this.handleImport(v.file);
    },
    onSuccess(response, file) {
      // this.handleImport(file)
    },
    onUploaded(file) {
      // 上传文件成功事件
      this.handleImport(file);
    },
    onProgress(file, progress, event) {
      // 上传进度事件，回调参数（file：上传的文件，progress：已上传比例，event：进度事件参数）
      const f = this.getFile(file.uuid);
      if (f) {
        f.percentage = progress.toFixed(2) * 100;
      }
    },
    getFile(uuid) {
      if (this.file.uuid === uuid) {
        return this.file;
      }
    },
    beforeUpload(file) {
      let Xls = file.name.split('.');
      if (Xls[Xls.length - 1] === 'xls' || Xls[Xls.length - 1] === 'xlsx') {
        this.file = {
          uuid: file.uuid,
          percentage: 0
        };
        if (Xls[0].length > 13) {
          this.file.name = Xls[0].slice(0, 13) + '...' + Xls[Xls.length - 1];
        } else {
          this.file.name = file.name;
        }
        this.uploadShow = true;
        this.uploading = true;
      } else {
        this.$message.warning(this.$t('pc_gwnl_import_wrongFormat'));
        return false;
      }
    },
    filesFilter(files) {
      if (files[0] && !/.xlsx?$/.test(files[0].name)) {
        this.$message.warning(this.$t('pc_gwnl_import_wrongFormat'));
        return [];
      }
      return files;
    }
  }
};
</script>
<style lang="scss">
.eval_addreport_drawer {
  .addHeader-box {
    display: flex;

    .setp-item {
      display: flex;
      flex-grow: 1;
      align-items: center;
      justify-content: flex-start;
      padding: 0 12px;

      &.unset {
        .step-text {
          color: #595959;
        }

        .gwnl-eval-step__index {
          color: #8c8c8c;
          font-weight: 400;
          background: #f0f0f0;
        }
      }

      &.setp-item1 {
        justify-content: flex-end;
      }

      &.past {
        .gwnl-eval-step--done {
          width: 16px;
          height: 16px;
          color: #bdd2ff;
        }

        .step-text {
          color: #595959;
        }
      }

      .step-text {
        margin-left: 8px;
        color: #436bff;
        font-weight: 400;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 22px;
      }

      .gwnl-eval-step__index {
        display: inline-block;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 16px;
        height: 16px;
        color: #fff;
        font-weight: bold;
        font-size: 10px;
        font-family: DINPro-Bold, DINPro;
        line-height: 12px;
        background: #436bff;
        border-radius: 50%;
      }
    }
  }
}

.yxt-upload-explain__section {
  .card {
    display: inline-block;
    flex: 1;
    box-sizing: border-box;
    height: 80px;
    padding: 10px 0;
    line-height: 22px;
    text-align: center;
    background: rgba(255, 255, 255, 1);
    border-style: solid;
    border-width: 1px;
    border-radius: 4px;
    cursor: pointer;

    &.active {
      background: rgba(247, 250, 255, 1);
    }
  }

  .content {
    box-sizing: border-box;
    width: 328px;
    padding: 12px 16px;
    color: rgba(89, 89, 89, 1);
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    background: rgba(250, 250, 250, 1);
  }

  /deep/ .yxt-link {
    .yxt-link--inner {
      font-size: 12px;
      line-height: 20px;
    }

    &.standard-size-14 .yxt-link--inner {
      font-size: 14px;
      line-height: 22px;
    }
  }
}

.yxt-upload-item-list li.is-active .yxt-upload-status {
  top: 6px;
  left: 0;
  width: 10px;
  height: 10px;
}

.yxt-upload-item-list .yxt-upload-item-title {
  font-weight: 400;
}

.reportsProjectSelectModel {
  .yxt-upload-explain-list {
    li {
      &:first-of-type {
        padding-bottom: 80px;
      }
    }
  }
}

.yxt-upload-explain-list .yxt-upload-explain-title {
  font-weight: 500;
}
</style>
